export enum ETopicsPerm {
    TOPICS_VIEW = 'topics_view',
    TOPICS_EDIT = 'topics_edit',
    TOPICS_DELETE = 'topics_delete'
}
